import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Mail, Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import api from '../lib/api';

const ConfirmEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const confirmEmail = async () => {
      if (!token) {
        setError('Lien de confirmation invalide');
        setLoading(false);
        return;
      }

      try {
        await api.confirmEmail(token);
        setSuccess(true);
        toast.success('Email confirmé !');
      } catch (err) {
        setError(err.response?.data?.detail || 'Erreur lors de la confirmation');
      } finally {
        setLoading(false);
      }
    };

    confirmEmail();
  }, [token]);

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-emerald-400 animate-spin mx-auto mb-4" />
          <p className="text-slate-400">Confirmation en cours...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
        <div className="w-full max-w-md">
          <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertCircle className="w-8 h-8 text-red-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-4">Erreur de confirmation</h1>
            <p className="text-slate-400 mb-6">{error}</p>
            <Link to="/login">
              <Button className="w-full bg-blue-600 hover:bg-blue-700">
                Retour à la connexion
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Success state
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <div className="w-full max-w-md">
        <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-emerald-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-4">Email confirmé !</h1>
          <p className="text-slate-400 mb-6">
            Votre adresse email a été vérifiée avec succès. Votre compte est maintenant actif.
          </p>
          <Link to="/login">
            <Button className="w-full bg-emerald-600 hover:bg-emerald-700">
              Se connecter
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmailPage;
